<template>
  <div class="home">

    <!-- ── HERO ── -->
    <section class="hero">
      <div class="hero-inner">
        <div class="hero-text">
          <p class="eyebrow">{{ t('home.tagline') }}</p>
          <h1 class="hero-title">Manolito</h1>
        </div>
        <div class="hero-aside">
          <p class="hero-desc">{{ t('home.desc') }}</p>
          <router-link to="/cuidados" class="cta-btn">{{ t('home.cta') }}</router-link>
        </div>
      </div>

      <!-- Landscape + circle photo -->
      <div class="photo-strip">
        <div class="landscape-bg" :style="{ backgroundImage: `url(${bgImage})` }"></div>
        <div class="circle-photo" :style="{ backgroundImage: `url(${litoImg})` }"></div>
      </div>
    </section>

    <!-- ── IF LOST — TYPEFORM ── -->
    <section class="lost-section">
      <div class="container">
        <h2 class="section-title">{{ t('lost.title') }}</h2>
        <p class="section-desc">{{ t('lost.desc') }}</p>
        <div class="form-wrapper">
          <iframe
            src="https://docs.google.com/forms/d/e/1FAIpQLSfZrbjFObGUmDEBDItqkSjVfelafrFfNYzRzBe8-3PE18WVjw/viewform?embedded=true"
            width="100%"
            height="640"
            frameborder="0"
            marginheight="0"
            marginwidth="0"
          >Cargando…</iframe>
        </div>
      </div>
    </section>

    <footer class="footer">{{ t('footer') }}</footer>
  </div>
</template>

<script>
import { useI18n } from 'vue-i18n'
import backgroundImage from '@/assets/manolito_background.png'
import litoImage from '@/assets/lito.jpg'

export default {
  name: 'HomeView',
  setup() {
    const { t } = useI18n()

    return { t, bgImage: backgroundImage, litoImg: litoImage }
  }
}
</script>

<style scoped>
.home { background: #F5F4EF; min-height: 100vh; }

/* ── HERO ── */
.hero { padding-top: 62px; /* navbar height */ }

.hero-inner {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  padding: 56px 48px 44px;
  gap: 48px;
  min-height: 340px;
}

.eyebrow {
  font-family: 'Inter', sans-serif;
  font-size: 0.72rem;
  font-weight: 500;
  letter-spacing: 0.18em;
  text-transform: uppercase;
  color: #999;
  margin-bottom: 12px;
}

.hero-title {
  font-family: 'Playfair Display', Georgia, serif;
  font-size: clamp(4.5rem, 11vw, 9.5rem);
  font-weight: 700;
  line-height: 0.88;
  color: #1a1a1a;
  letter-spacing: -0.02em;
}

.hero-aside {
  flex: 0 0 260px;
  padding-bottom: 16px;
}

.hero-desc {
  font-family: 'Inter', sans-serif;
  font-size: 0.9rem;
  line-height: 1.7;
  color: #555;
  margin-bottom: 20px;
  white-space: pre-line;
}

.cta-btn {
  display: inline-flex;
  align-items: center;
  background: #E8C547;
  color: #1a1a1a;
  font-family: 'Inter', sans-serif;
  font-size: 0.85rem;
  font-weight: 600;
  padding: 12px 22px;
  border-radius: 99px;
  text-decoration: none;
  transition: background 0.2s, transform 0.15s;
}
.cta-btn:hover { background: #d4b23a; transform: translateY(-1px); }

/* ── PHOTO STRIP ── */
.photo-strip {
  position: relative;
  height: 300px;
  margin: 0 40px;
  border-radius: 24px;
  overflow: hidden;
  background: #ddd;
  display: flex;
  align-items: center;
  justify-content: center;
}
.landscape-bg {
  position: absolute;
  inset: 0;
  background-size: cover;
  background-position: center 30%;
  filter: brightness(0.55) saturate(0.8);
}
.circle-photo {
  position: relative;
  z-index: 1;
  width: 220px;
  height: 220px;
  border-radius: 50%;
  background-size: cover;
  background-position: center 20%;
  border: 5px solid #F5F4EF;
  box-shadow: 0 8px 40px rgba(0,0,0,0.3);
}

/* ── LOST / TYPEFORM ── */
.lost-section {
  background: #1a1a1a;
  padding: 80px 40px 0;
  margin-top: 80px;
}
.container { max-width: 760px; margin: 0 auto; }

.section-title {
  font-family: 'Playfair Display', serif;
  font-size: clamp(1.8rem, 4vw, 2.6rem);
  font-weight: 700;
  color: #fff;
  margin-bottom: 16px;
}
.section-desc {
  font-size: 1rem;
  line-height: 1.7;
  color: rgba(255,255,255,0.55);
  margin-bottom: 36px;
  max-width: 520px;
}

.form-wrapper {
  border-radius: 16px;
  overflow: hidden;
}
.form-wrapper iframe {
  display: block;
  border-radius: 16px;
  background: white;
}

/* ── FOOTER ── */
.footer {
  background: #1a1a1a;
  color: rgba(255,255,255,0.3);
  text-align: center;
  padding: 28px;
  font-size: 0.82rem;
  font-family: 'Inter', sans-serif;
  border-top: 1px solid rgba(255,255,255,0.06);
}

/* ── RESPONSIVE ── */
@media (max-width: 640px) {
  .hero-inner { flex-direction: column; padding: 40px 20px 24px; }
  .hero-aside { flex: unset; }
  .photo-strip { margin: 0 20px; height: 240px; }
  .circle-photo { width: 170px; height: 170px; }
  .lost-section { padding: 60px 20px; }
}
</style>
